export const colorPalettes = {
  // ===========================
  // ⭐ 4계절 기본 팔레트
  // ===========================
  spring: {
    best: ["#FFB3AB", "#FFD1A9", "#FFE596", "#E0FF8A", "#A8FFBD", "#A4F7FF", "#C5B3FF"],
    worst: ["#003366", "#330044", "#4B0082", "#000000"]
  },

  summer: {
    best: ["#C4E3FF", "#A6D1FF", "#D3C7FF", "#FFC4D6", "#FFE8E3", "#F4F7FF"],
    worst: ["#FF6600", "#663300", "#552200", "#000000"]
  },

  autumn: {
    best: ["#CC5500", "#B5651D", "#A97142", "#D2691E", "#8B4513", "#C19A6B"],
    worst: ["#66CCFF", "#99DDFF", "#CCEEFF", "#FFFFFF"]
  },

  winter: {
    best: ["#00008B", "#4B0082", "#9932CC", "#00FFFF", "#FFFFFF", "#000000", "#FF1493"],
    worst: ["#CC9900", "#996633", "#FFCC66"]
  },

  // ===========================
  // ⭐ 12톤 세부 팔레트
  // ===========================
  // ---- Spring 3종 ----
  "Bright Spring": {
    best: ["#FF6F61", "#FFA177", "#FFD479", "#8FFFBD", "#6FE7FF"],
    worst: ["#003355", "#330044"]
  },

  "Light Spring": {
    best: ["#FFCCB3", "#FFE3A4", "#FFF7B2", "#C1FFCF", "#C6F7FF"],
    worst: ["#000044", "#220033"]
  },

  "Warm Spring": {
    best: ["#E89B61", "#FFBE7A", "#FFD68A", "#D1FF8A"],
    worst: ["#002244"]
  },

  // ---- Summer 3종 ----
  "Bright Summer": {
    best: ["#D4E8FF", "#B9D4FF", "#E3D7FF", "#FFD4E8"],
    worst: ["#553300", "#FF5500"]
  },

  "Soft Summer": {
    best: ["#C7C8D9", "#D6CEDB", "#E7D8E9", "#F5DFE6"],
    worst: ["#330000", "#552200"]
  },

  "Light Summer": {
    best: ["#DDEBFA", "#CDE0F7", "#ECDCF8", "#FBE6F1"],
    worst: ["#332200"]
  },

  // ---- Autumn 3종 ----
  "Warm Autumn": {
    best: ["#D77F47", "#BF6B3F", "#D9A066", "#C39B6B"],
    worst: ["#003344"]
  },

  "Soft Autumn": {
    best: ["#C1A083", "#D2B48C", "#E3C6A8", "#D8C3A5"],
    worst: ["#003366"]
  },

  "Deep Autumn": {
    best: ["#8C4B1F", "#6A3A1C", "#A65E2E", "#C2763E"],
    worst: ["#99DDFF"]
  },

  // ---- Winter 3종 ----
  "Bright Winter": {
    best: ["#00D4FF", "#008CFF", "#B400FF", "#FF007F"],
    worst: ["#CC9900"]
  },

  "Cool Winter": {
    best: ["#0022FF", "#4B00CC", "#AA00FF", "#00FFFF", "#FFFFFF"],
    worst: ["#CC6600"]
  },

  "Deep Winter": {
    best: ["#000033", "#220044", "#550087", "#8800CC"],
    worst: ["#FFDD88"]
  },
};
